import { render, staticRenderFns } from "./EpochTeacherSelect.vue?vue&type=template&id=08ac3d52"
import script from "./EpochTeacherSelect.vue?vue&type=script&lang=js"
export * from "./EpochTeacherSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports